
{
  "familyId": "MET-MEETK-DIAMETER",
  "questions": [
    {
      "id": "MET-MEETK-DIAMETER-001",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een diameter van 14 cm. Hoe lang is de straal?",
      "options": ["7 cm", "28 cm", "14 cm", "3,5 cm"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"diameter":14,"highlightDiameter":true,"label":"Cirkel met diameter 14 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Diameter en straal",
            "content": "De diameter is de afstand dwars door het midden van de cirkel. De straal is de helft van de diameter: straal = diameter ÷ 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diameter_naar_straal",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De straal is de helft van de diameter: straal = diameter ÷ 2 = 14 ÷ 2 = 7 cm. Waarom de helft? De diameter loopt van rand tot rand dóór het middelpunt — dat is twee keer de afstand van het middelpunt naar de rand (de straal). Onthoud: diameter = 2 × straal, dus straal = diameter ÷ 2.",
        "solutionSteps": [
          "Formule: straal = diameter ÷ 2",
          "Invullen: 14 ÷ 2 = 7 cm",
          "Check: 2 × 7 = 14 cm (diameter) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De straal is de helft van de diameter: 14 ÷ 2 = 7 cm.",
          "1": "Je hebt de diameter verdubbeld in plaats van gehalveerd. Maar de straal is de helft, niet het dubbele. Onthoud: straal = diameter ÷ 2, niet × 2.",
          "2": "Je hebt de diameter overgenomen alsof straal en diameter hetzelfde zijn. Maar de straal gaat alleen van middelpunt naar rand — half zo lang als de diameter. Onthoud: diameter = 2 × straal.",
          "3": "Je hebt door 4 gedeeld in plaats van door 2: 14 ÷ 4 = 3,5. Maar de straal is precies de helft van de diameter. Onthoud: straal = diameter ÷ 2."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.straal-diameter-omgedraaid", "label": "×2 i.p.v. ÷2", "optionIndex": 1 },
          { "id": "met.straal-gelijk-aan-diameter", "label": "Straal = diameter", "optionIndex": 2 },
          { "id": "met.straal-diameter-deel-4", "label": "Diameter ÷ 4", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-002",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Een fietswiel heeft een straal van 35 cm. Hoe groot is de diameter?",
      "options": ["17,5 cm", "35 cm", "70 cm", "105 cm"],
      "correctAnswer": 2,
      "stimulusAids": [{"type":"circle","data":{"radius":35,"highlightRadius":true,"label":"Fietswiel met straal 35 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van straal naar diameter",
            "content": "De diameter is twee keer de straal: diameter = straal × 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "straal_naar_diameter",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De diameter is twee keer de straal: diameter = straal × 2 = 35 × 2 = 70 cm. De diameter gaat van de ene kant van het wiel naar de andere, dwars door het middelpunt — dat is twee keer een straal. Onthoud: diameter = 2 × straal.",
        "solutionSteps": [
          "Formule: diameter = straal × 2",
          "Invullen: 35 × 2 = 70 cm",
          "Check: 70 ÷ 2 = 35 cm (straal) ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de straal gehalveerd in plaats van verdubbeld. Maar de diameter is het dúbbele van de straal, niet de helft. Onthoud: diameter = straal × 2.",
          "1": "Je hebt de straal overgenomen alsof straal en diameter hetzelfde zijn. Maar de diameter loopt door de hele cirkel, de straal maar tot het midden. Onthoud: diameter = 2 × straal.",
          "2": "Goed! De diameter is twee keer de straal: 35 × 2 = 70 cm.",
          "3": "Je hebt met 3 vermenigvuldigd: 35 × 3 = 105. Maar de diameter is 2 keer de straal, niet 3 keer. Onthoud: factor 2, niet 3."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.straal-diameter-omgedraaid", "label": "÷2 i.p.v. ×2", "optionIndex": 0 },
          { "id": "met.straal-gelijk-aan-diameter", "label": "Diameter = straal", "optionIndex": 1 },
          { "id": "met.diameter-keer-3", "label": "× 3 i.p.v. × 2", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-003",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Welke uitspraak over een cirkel is WAAR?",
      "options": ["De straal is langer dan de diameter", "De diameter gaat altijd door het middelpunt", "Een cirkel heeft maar één straal", "De diameter is de helft van de straal"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"label":"Cirkel"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Begrippen bij een cirkel",
            "content": "Middelpunt = het midden. Straal = van middelpunt naar rand. Diameter = van rand tot rand, door het middelpunt. Diameter = 2 × straal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_begrippen",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De diameter is de lijn die van de ene kant van de cirkel naar de andere gaat, altijd door het middelpunt — dat is een definitie. De straal is de helft van de diameter, dus altijd korter. En je kunt vanuit het middelpunt naar elk punt op de rand een straal trekken: er zijn dus oneindig veel stralen, allemaal even lang.",
        "solutionSteps": [
          "Diameter = lijn door het middelpunt, van rand tot rand",
          "Straal = van middelpunt naar rand, half de diameter",
          "Een cirkel heeft oneindig veel even lange stralen"
        ],
        "distractorExplanations": {
          "0": "Je hebt de begrippen omgedraaid: de straal is juist de helft van de diameter, dus korter. Onthoud: diameter = 2 × straal, dus de diameter is altijd langer.",
          "1": "Goed! De diameter gaat altijd door het middelpunt — dat is precies wat een diameter onderscheidt van een willekeurige koorde.",
          "2": "Je denkt aan de straal als één unieke lijn. Maar je kunt vanuit het middelpunt naar elk punt op de rand een straal trekken — er zijn er oneindig veel, allemaal even lang.",
          "3": "Je hebt straal en diameter omgedraaid. De diameter is het dúbbele van de straal, niet de helft. Onthoud: diameter = 2 × straal."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-langer", "label": "Straal langer dan diameter", "optionIndex": 0 },
          { "id": "met.cirkel-een-straal", "label": "Eén unieke straal", "optionIndex": 2 },
          { "id": "met.cirkel-diameter-helft", "label": "Diameter = ½ straal", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-004",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Een tuinier maakt een rond bloemperk met een diameter van 3 meter. Hoe ver is het van het midden tot de rand?",
      "options": ["3 meter", "6 meter", "0,75 meter", "1,5 meter"],
      "correctAnswer": 3,
      "stimulusAids": [{"type":"circle","data":{"diameter":3,"highlightDiameter":true,"label":"Rond bloemperk ∅ 3 m"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van midden tot rand = straal",
            "content": "De afstand van het midden tot de rand is de straal. Straal = diameter ÷ 2 = 3 ÷ 2 = 1,5 m.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diameter_straal_context",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Van het midden tot de rand is per definitie de straal. De straal is de helft van de diameter: 3 ÷ 2 = 1,5 meter. De tuinier hoeft dus 1,5 m vanaf het midden te meten om de rand te bereiken. Onthoud: 'midden naar rand' = straal = diameter ÷ 2.",
        "solutionSteps": [
          "Van midden tot rand = straal (definitie)",
          "Straal = diameter ÷ 2",
          "3 ÷ 2 = 1,5 meter"
        ],
        "distractorExplanations": {
          "0": "Je hebt de diameter genomen. Maar van midden tot rand is de stráál — half de diameter. Onthoud: midden→rand = straal = diameter ÷ 2.",
          "1": "Je hebt de diameter verdubbeld (3 × 2 = 6). Maar van midden tot rand is juist de helft van de diameter: 1,5 m. Onthoud: kleinere afstand → delen, niet vermenigvuldigen.",
          "2": "Je hebt door 4 gedeeld: 3 ÷ 4 = 0,75. Maar de straal is de helft van de diameter, dus deel door 2. Onthoud: factor 2, niet 4.",
          "3": "Goed! De straal is de helft van de diameter: 3 ÷ 2 = 1,5 meter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.straal-gelijk-aan-diameter", "label": "Diameter als afstand midden→rand", "optionIndex": 0 },
          { "id": "met.straal-diameter-omgedraaid", "label": "× 2 i.p.v. ÷ 2", "optionIndex": 1 },
          { "id": "met.straal-diameter-deel-4", "label": "÷ 4 i.p.v. ÷ 2", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-005",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "fill_in",
      "question": "Een cirkel heeft een straal van 9 cm. Hoe groot is de diameter? Typ je antwoord in cm (bijv. 18).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["18", "18 cm"],
        "caseSensitive": false,
        "placeholder": "? cm"
      },
      "stimulusAids": [{"type":"circle","data":{"radius":9,"highlightRadius":true,"label":"Cirkel met straal 9 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Diameter berekenen",
            "content": "Diameter = straal × 2. Dus: 9 × 2 = 18 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "straal_naar_diameter_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Diameter = straal × 2 = 9 × 2 = 18 cm. De diameter loopt van de ene kant van de cirkel naar de andere, dwars door het middelpunt. Controleer: 18 ÷ 2 = 9 cm ✓.",
        "solutionSteps": [
          "Formule: diameter = straal × 2",
          "Invullen: 9 × 2 = 18 cm",
          "Check: 18 ÷ 2 = 9 cm (straal) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}
